import classnames from 'classnames';
import * as React from 'react';
import { HeadingLevelContext } from './heading_level_provider.js';
import { heading, title, display } from './heading.css.js';

/**
 * Heading is used to introduce a section of content in a hierarchical way.
 */
const Heading = ({ children, className, ...rest }) => {
    const { level } = React.useContext(HeadingLevelContext);
    const Element = `h${level}`;
    const { type, size, ...nativeProps } = rest;
    return (React.createElement(Element, { ...nativeProps, className: classnames(heading, getSizeClass(rest), className) }, children));
};
const getSizeClass = ({ type, size }) => {
    switch (type) {
        case 'display':
            return display[size ?? 'medium'];
        case 'title':
        default:
            return title[size ?? 'xlarge'];
    }
};

export { Heading };
